// BULK SEND POPUP DATA ***************************************************************************
// pathname: /v3/bulk-operation/send-data
// ************************************************************************************************
import { useSwrApi, ApiBulkSendDataList } from 'src/hooks/useSwrApi';


/**
 * @description Get the default email addresses for the bulk send popup.
 * @param locale - the locale
 */
export const useSwrBulkSendPopupData = (locale = 'ro') => {
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSwrApi<ApiBulkSendDataList>({
    url: '/v3/bulk-operation/send-data',
    locale,
    apiOptions: {
      dedupingInterval: 1000 * 60, // 1 minute
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  // Return data
  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};
